import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { IBackupSettings } from '../../../types/settings'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductBackupSettings = createAsyncThunk<
    { guid: string; data: IBackupSettings },
    { guid: string },
    ThunkConfig<string>
>('coreSettingsSlice/fetchProductBackupSettings', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid } = args
    try {
        const { data } = await api.get(
            getUrlWithVersion(`/products/${guid}/core_settings/backup`)
        )
        return { guid, data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch backup  settings')
    }
})
